<div class="header" [class.small]="small">
  <a routerLink="/instrumententafel">
    <img *ngIf="companyLogo | async as logo" alt="logo-img" [ngClass]="isTenantLew ? 'lew-logo' : 'logo'" [attr.src]="logo" />
  </a>
  <div *ngIf="isDsoUser; else municipalityDropDown">
    <app-dso-dropdown></app-dso-dropdown>
  </div>

  <ng-template #municipalityDropDown>
    <app-multipurpose-dropdown
      class="dropdown-municipality"
      *ngIf="!hideDropdown"
      selectedMunicipality="{{ selectedMunicipalityText }}"
      [municipalities]="municipalities"
      [displaySearch]="small"
      (municipalityChange)="setMunicipality($event)"
    ></app-multipurpose-dropdown>
  </ng-template>

  <div class="user-links" *ngIf="!small">
    <a class="link-menu" routerLink="/instrumententafel">
      <span class="fa fa-th fa-2x"></span>
      <span class="link-name">{{ 'module.layout.header.menuText' | translate }}</span>
    </a>
    <div class="divider"></div>
    <span class="name">{{ 'module.layout.header.message' | translate : { name: firstname + ' ' + lastname } }}</span>
    <div class="header-icons-class">
      <div class="header-icon contact-submenu" (click)="contactMenuTrigger.openMenu()">
        <div class="contact-icon">
          <app-svg-icon class="phone-icon-image" src="./assets/icons/icon_phone.svg"></app-svg-icon>
        </div>
      </div>
      <div class="user-profile-submenu user-menu-icon" *ngIf="!!authService.permissions.DESIGN_WIZARD">
        <span class="cog-icon icon-image fa fa-cog fa-2x" (click)="designSettingMenuTrigger.openMenu()"></span>
      </div>
      <div class="user-profile-submenu user-menu-icon">
        <span class="user-icon icon-image fa fa-user-circle fa-2x" (click)="userProfileMenuTrigger.openMenu()"></span>
      </div>
      <div class="" [matMenuTriggerFor]="contactMenu" #contactMenuTrigger="matMenuTrigger">
        <mat-menu #contactMenu="matMenu" class="header-mat-menu" yPosition="below" xPosition="before">
          <app-contact-info [showFooterText]="true" class="app-contact header-contact-info"></app-contact-info>
        </mat-menu>
      </div>
      <div [matMenuTriggerFor]="userProfileMenu" #userProfileMenuTrigger="matMenuTrigger">
        <mat-menu #userProfileMenu="matMenu" class="header-mat-menu" yPosition="below" xPosition="before">
          <app-user-profile-menu></app-user-profile-menu>
        </mat-menu>
      </div>
      <div [matMenuTriggerFor]="designSettingMenu" #designSettingMenuTrigger="matMenuTrigger">
        <mat-menu #designSettingMenu="matMenu" class="header-mat-menu" yPosition="below" xPosition="before">
          <app-design-settings-menu></app-design-settings-menu>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
